import { makeStyles } from '@material-ui/core'
import React from 'react'
import PropTypes from 'prop-types'

const useStyles = makeStyles(theme => ({
    status: {
        marginBottom: 0,
        color: props => {
            const state = props.status

            switch(state?.toLowerCase()){
                case 'done':
                    return '#57CB20'
                case 'error':
                    return '#FF0000'
                case  'stopped':
                    return '#676767'
                default:
                    return '#2046CB'
            }
        }
    },
}))

/** Colorized status text component */
const JobStatus = ({status}) => {
    const classes = useStyles({status})

    /**
     * Convert the given text to title case
     *
     * @param {string} text - string to convert to title
     */
     const titleCase = text => text[0].toUpperCase() + text.slice(1)

     return <p className={classes.status}>{status && titleCase(status)}</p>
}


// status props

JobStatus.propTypes = {
    status: PropTypes.string
}

export default JobStatus
